var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRomeKeeper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_57)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#250D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9996 34.7613C16.4461 34.2079 16.4461 33.3106 16.9996 32.7572C17.553 32.2037 18.4503 32.2037 19.0037 32.7572C19.5572 33.3106 19.5572 34.2079 19.0037 34.7613C18.4503 35.3148 17.553 35.3148 16.9996 34.7613Z",
    stroke: "#FFCA7A",
    strokeWidth: 0.773954
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.088 18.6373C43.5345 18.0839 43.5345 17.1866 44.088 16.6331C44.6414 16.0797 45.5387 16.0797 46.0921 16.6331C46.6456 17.1866 46.6456 18.0839 46.0921 18.6373C45.5387 19.1907 44.6414 19.1907 44.088 18.6373Z",
    stroke: "#FFCA7A",
    strokeWidth: 0.773954
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68019 42.5009C6.12675 41.9474 6.12675 41.0501 6.68019 40.4967C7.23362 39.9433 8.13092 39.9433 8.68435 40.4967C9.23778 41.0501 9.23778 41.9474 8.68435 42.5009C8.13092 43.0543 7.23362 43.0543 6.68019 42.5009Z",
    stroke: "#FFCA7A",
    strokeWidth: 0.773954
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29053 40.462C-1.57058 12.6129 33.0478 -7.78274 52.9332 16.4582C53.5755 17.2412 53.4584 18.4013 52.6931 19.0646L45.935 24.9216C45.0906 25.6535 43.8054 25.5172 43.0199 24.7224C40.3307 22.0014 35.3163 18.6479 28.8967 20.1458C21.1572 21.9517 17.9324 28.5303 17.9324 32.4",
    stroke: "#FFCA7A",
    strokeWidth: 1.03194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0533 16.9209C32.7093 7.46755 9.04867 14.6415 12.1857 36.9383C12.315 37.8574 13.1234 38.5143 14.045 38.6234C20.8943 39.4345 28.2713 45.2476 30.4468 51.3944C30.7219 52.1716 31.3812 52.777 32.2006 52.8675L45.6507 54.3535C46.9708 54.4994 48.042 53.3024 47.7511 52.0065L47.3313 50.1365M47.3313 50.1365L44.8829 39.2302C44.8265 38.979 44.7206 38.7416 44.5713 38.5319L40.6051 32.9607C40.4433 32.7335 40.6269 32.4219 40.9041 32.4533L47.6493 33.2159C48.4547 33.307 49.118 33.8904 49.3111 34.6776L52.5598 47.9223C52.8694 49.1844 51.8716 50.3867 50.5741 50.3152L47.3313 50.1365Z",
    stroke: "#FFCA7A",
    strokeWidth: 1.03194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7631 38.0407C28.7922 37.9389 28.8188 37.813 28.8431 37.6628C28.8721 37.5126 28.8963 37.3261 28.9157 37.1032C28.9351 36.8803 28.9496 36.6163 28.9593 36.311C28.969 36.001 28.9739 35.64 28.9739 35.2282L28.9739 30.4971C28.9739 30.0853 28.969 29.7267 28.9593 29.4215C28.9496 29.1114 28.9351 28.845 28.9157 28.6221C28.8963 28.3944 28.8721 28.2054 28.8431 28.0552C28.8188 27.905 28.7922 27.7791 28.7631 27.6773V27.6483L30.5073 27.6483V27.6773C30.4782 27.7791 30.4492 27.905 30.4201 28.0552C30.3959 28.2054 30.3741 28.3944 30.3547 28.6221C30.3401 28.845 30.3256 29.1114 30.3111 29.4215C30.3014 29.7267 30.2965 30.0853 30.2965 30.4971V32.1177L34.5407 28.6512C35.0155 28.2636 35.2529 27.9293 35.2529 27.6483L37.2951 27.6483V27.6773C37.0092 27.7452 36.7185 27.876 36.423 28.0698C36.1323 28.2587 35.8222 28.4913 35.4928 28.7674L31.7428 31.907L36.2558 36.8634C36.4448 37.0572 36.6047 37.2195 36.7355 37.3503C36.8712 37.4763 36.9899 37.5828 37.0916 37.6701C37.1933 37.7524 37.2854 37.8227 37.3678 37.8808C37.455 37.9341 37.5446 37.9874 37.6367 38.0407V38.0698H35.5073C35.4879 38.0262 35.454 37.9704 35.4056 37.9026C35.3619 37.8348 35.3087 37.7645 35.2457 37.6919C35.1875 37.6192 35.1221 37.5441 35.0494 37.4666C34.9816 37.389 34.9162 37.3164 34.8532 37.2485L30.2965 32.2485L30.2965 35.2282C30.2965 35.64 30.3014 36.001 30.3111 36.311C30.3256 36.6163 30.3401 36.8803 30.3547 37.1032C30.3741 37.3261 30.3959 37.5126 30.4201 37.6628C30.4492 37.813 30.4782 37.9389 30.5073 38.0407V38.0698L28.7631 38.0698V38.0407Z",
    fill: "#FFCA7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomeKeeper);
export default __webpack_public_path__ + "static/media/ROME-KEEPER.ef1be63a759b7972dedc617bab3d7bd9.svg";
export { ForwardRef as ReactComponent };